import React, { useEffect, useState, useContext } from 'react';
import { ExperienceContext, useConfigService } from '@thd-nucleus/experience-context';
import thdcustomer from '@thd-olt-global/thd-customer';
import { Loader } from '@thd-olt-component-react/loader';
import { AppContext } from '@thd-nucleus/app-render';
import * as utils from './Utils';
import { SaveCardForm } from './SaveCardForm';
import { readThdSctpCookie, deleteBrowserCookie } from './SaveCardCookieUtility';
import { addDiscountCodeToLocalStorage } from './DiscountCodeUtility';
import { saveCard, redirectToPaymentCardsPage } from './SaveCardUtility';

export const SaveCardToProfile = () => {

  const [saveCardFormParams, setSaveCardFormParams] = useState(null);
  const [returnFromCiti, setReturnFromCiti] = useState(false);
  const { channel } = useContext(ExperienceContext);
  const { instance } = useContext(AppContext);
  const isSCTPEnabled = useConfigService('fs:CONSUMER_SCTP_ENABLED');
  const isNativeAppEnabled = useConfigService('fs:NATIVE_APP_SCTP_ENABLED');
  const isGuestNativeAppEnabled = useConfigService('fs:GUEST_NATIVE_APP_SCTP_ENABLED');
  const applyMyOfferEnabled = useConfigService('fs:APPLY_MY_OFFER_ENABLED');

  const overrideFS = (cookieName) => {
    return window.cookieUtils && window.cookieUtils.readBrowserCookie(cookieName);
  };

  const nativeAppCheck = () => {
    const isNativeApp = instance?.expContext?.experienceContext?.isConsumerApp;
    let enabled = true;
    if (isNativeApp) {
      enabled = isNativeAppEnabled || overrideFS('NATIVE_APP_SCTP_ENABLED');
      if (!thdcustomer.isLoggedIn) {
        enabled = isGuestNativeAppEnabled || overrideFS('GUEST_NATIVE_APP_SCTP_ENABLED');
      }
    }
    return enabled;
  };

  const isInDocument = (elementId) => {
    return window.document.getElementById(elementId)
      && window.document.getElementById(elementId).value;
  };

  const redirectToOriginPage = () => {
    const originPage = utils.getOriginPageUrl();
    window.location.href = originPage || 'https://www.homedepot.com';
  };

  const invokeSaveCardApi = async () => {
    if (thdcustomer.isB2BCustomer) {
      redirectToPaymentCardsPage(false, 'PLCN_HOMEDEPOT');
    } else {
      saveCard(channel === 'mobile', false);
    }
  };

  const invokeSaveCardAfterApply = () => {
    if (applyMyOfferEnabled || overrideFS('APPLY_MY_OFFER_ENABLED')) {
      addDiscountCodeToLocalStorage();
    }
    const sctpCookie = readThdSctpCookie();
    const returnFromLoginWithCookie = sctpCookie && sctpCookie.r;
    const redirectFromCitiApproval = isInDocument('referenceId')
      && isInDocument('status')
      && window.document.getElementById('status').value === 'A';
    if (redirectFromCitiApproval || returnFromLoginWithCookie) {
      invokeSaveCardApi();
    } else {
      deleteBrowserCookie('THD_SCTP', utils.getDomain());
      redirectToOriginPage();
    }
  };

  const redirectToCiti = () => {
    const defaultCitiUrl = 'https://citiretailservices.citibankonline.com/CRS/acq/launch/'
      + 'index.action?app=UNSOL&siteId=PLCN_HOMEDEPOT&sc=30005';
    const cmpId = utils.getURLParameters().cmp ? '&cmp=' + utils.getURLParameters().cmp : '';
    window.location.href = defaultCitiUrl + cmpId;
  };

  const getRedirectUrl = async () => {
    return utils.getRedirectUrl(channel === 'mobile', false);
  };

  const getReturnPage = () => {
    const originUrlParam = utils.getOriginPageUrl() ? '?originUrl=' + encodeURIComponent(utils.getOriginPageUrl()) : '';
    return '/myaccount/savecardtoprofile' + originUrlParam;
  };

  const initSCTP = () => {
    if (!thdcustomer.isB2BCustomer) {
      getRedirectUrl()
        .then((data) => {
          if (data && data.customerId) {
            const formDataObject = { ...data };
            formDataObject.returnPage = getReturnPage();
            setSaveCardFormParams(formDataObject);
          } else {
            redirectToCiti();
          }
        });
    } else {
      redirectToCiti();
    }
  };

  useEffect(() => {
    if (window.document.getElementById('newRelicLog')
      && window.document.getElementById('newRelicLog').value) {
      console.log(window.document.getElementById('newRelicLog').value);
      utils.newRelic(null, window.document.getElementById('newRelicLog').value);
    }

    if (isInDocument('jweLog')) {
      console.log(window.document.getElementById('jweLog').value);
    } else {
      console.log('jweLog: Not in the document');
    }

    const sctpCookie = readThdSctpCookie();
    if (nativeAppCheck() && (isSCTPEnabled || overrideFS('CONSUMER_SCTP_ENABLED'))) {
      if (utils.getURLParameters().cmp || utils.getURLParameters().step) {
        initSCTP();
      } else if ((sctpCookie && sctpCookie.r) || isInDocument('referenceId')) {
        setReturnFromCiti(true);
        invokeSaveCardAfterApply();
      } else if (!(sctpCookie && sctpCookie.d)
        || (document.referrer && document.referrer.indexOf('/myaccount/payments') !== -1)) {
        const originPage = utils.getOriginPageUrl();
        window.location.href = originPage || 'https://www.homedepot.com';
      } else {
        redirectToPaymentCardsPage(false, 'PLCN_HOMEDEPOT');
      }
    } else {
      redirectToCiti();
    }
  }, []);

  const getLoaderMessage = () => {
    if (returnFromCiti) {
      return 'Saving Your Card';
    }
    return 'Redirecting To Citibank';
  };

  return (
    <div className="loader-container">
      <Loader active />
      <div className="u__husky u__bold u--paddingTop" id="loading-information-text">{getLoaderMessage()}</div>
      {(saveCardFormParams !== null) && <SaveCardForm formData={saveCardFormParams} />}
    </div>
  );
};

SaveCardToProfile.propTypes = {};

SaveCardToProfile.displayName = 'SaveCardToProfile';

SaveCardToProfile.defaultProps = {
  name: '',
};
